import { createSelector } from 'reselect';

const substate = (state) => state.policy;

export const selectPolicyHistory = () => createSelector(substate, (contextState) => contextState.policyHistory);
